// frontend/src/components/VotingResults.js

import React, { useEffect, useState } from 'react';
import { getVotingResults } from '../services/api';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend, ResponsiveContainer } from 'recharts';
import LoadingSpinner from './LoadingSpinner';
import '../styles/Dashboard.css';
import '../styles/VotingResults.css';
import { BarChart2, AlertCircle } from 'lucide-react';

const VotingResults = () => {
  const [votingResults, setVotingResults] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchVotingResults();
  }, []);

  const fetchVotingResults = async () => {
    try {
      const data = await getVotingResults();
      setVotingResults(data);
      setIsLoading(false);
    } catch (err) {
      console.error('投票結果の取得に失敗しました:', err);
      setError('投票結果の取得に失敗しました。');
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="dashboard-loading">
        <LoadingSpinner text="データを読み込んでいます..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-error">
        <AlertCircle size={48} color="var(--status-error-text)" />
        <p>{error}</p>
      </div>
    );
  }

  if (votingResults.length === 0) {
    return (
      <div className="dashboard-error">
        <AlertCircle size={48} color="var(--text-muted)" />
        <p>投票結果がありません。</p>
      </div>
    );
  }

  // グラフ用のデータ整形
  const chartData = votingResults.map(result => ({
    name: result.lottery_model_name,
    totalScore: result.total_score,
    averageRank: result.average_rank,
  }));

  return (
    <div className="dashboard voting-results voting-results-scope">
      <div className="dashboard-container">
        <div className="voting-results-header">
          <h1 className="dashboard-title voting-results-title">
            二次抽選モデル投票結果
          </h1>
          <p className="voting-results-subtitle">
            ユーザーによるモデルの順位付けの集計結果を表示します。
          </p>
        </div>

        <div className="dashboard-grid">
          <section className="dashboard-card voting-results-card">
            <div className="card-header voting-results-card-header">
              <h2 className="card-title">
                <BarChart2 size={24} className="icon-blue" />
                モデル別総得点
              </h2>
            </div>
            <div className="voting-results-chart">
              <ResponsiveContainer>
                <BarChart
                  data={chartData}
                  margin={{ top: 20, right: 20, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis allowDecimals={false} />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="totalScore" name="総得点" fill="#8884d8" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </section>

          <section className="dashboard-card voting-results-card">
            <div className="card-header voting-results-card-header">
              <h2 className="card-title">
                <BarChart2 size={24} className="icon-blue" />
                モデル別平均順位（値が小さいほど上位）
              </h2>
            </div>
            <div className="voting-results-chart">
              <ResponsiveContainer>
                <BarChart
                  data={chartData}
                  margin={{ top: 20, right: 20, left: 20, bottom: 5 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis allowDecimals={true} reversed={true} domain={[1, 4]} />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="averageRank" name="平均順位" fill="#82ca9d" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default VotingResults;
